import gql from 'graphql-tag'

export const LoadAccountsQueryForBankInputMixin = gql`
  query LoadAccountsQuery ($input: GetPermittedIbanCountriesInput!) {
    customerAccounts: getCustomerAccounts {
      accountNumber
      accountOwner
      counterpartyBankCode
    }

    savingsDepositIbans: getSavingsDepositIbans {
      value
    }

    permittedIbanCountries: getPermittedIbanCountries(input: $input) {
      value
    }
  }
`
